/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import { z } from 'zod/v4'

export const paginationMetaDataSchema = z.object({
	total: z.number(),
	limit: z.number(),
	offset: z.number(),
})

export type PaginationMetaDataSchema = z.infer<typeof paginationMetaDataSchema>
